import * as types from "../actions/action-types";

import { timeFilter, coachType, amenFilter, busServiceType, pickupsFilter, dropoffFilter, busFareFilter } from "../common/filters";

const initialState = {
  searchParams: "",
  data: [], // search API results ---- as is from API
  buses: [], // Bus data ---- to be used for sorting & filtering ---- can be reset based on data mentioned above
  // Static data to be updated once
  staticData: { coach: ["AC", "Non AC", "Seater", "Sleeper", "Premium", "mercedes benz"], serviceType: ["Swift Deluxe", "Super Deluxe", "Swift AC Garuda", "Swift AC Gajraj Sleeper"] },
  // Filtered data to be updated based on user input
  time: [],
  amenities: [],
  coach: [],
  serviceType: [],
  serviceTypeFilterList: [],
  stChrtStatus: {},
  stChrtOthrDtls: {},
  busImgDtls: {},
  tripDetails: {},
  order: [],
  header: [],
  currency: window.currency_symbol,
  couponDetails: {},
  loader: false,
  middleRoute: {},
  sortBy: 1,
  seatChartErrorMsg: {},
  pathDtls: {},
  routecodeDtls: {},
  busType: '',
  routePkpDrp: { pickups: [], dropoffs: [], pdroutes: [] },
  boardingPointFilter: [],
  droppingPointFilter: [],
  priceRangeFilter: [],
  fareRange: { min: 0, max: 0 },
  levyandConcData: {},
  orderToken: '',
  contactDetail: { mobile: '', email: '', loginType: '' },
  tripCode: '',
  showPassenger: {},
  pnrEnquiryData: false,
  pnrEnquiryTripData: { topDtls: {}, pickdropDtls: {} },
  loginData: { mobile: '', email: '', password: '' },
  recaptchaToken: '',
  staticCityList: {},
  cityList: {},
  packageData:[],
  packageCity:['All'],
  packageCategory:['All'],
  packageTour:['All'],
};

const searchReducer = function (state = initialState, action) {
  let currState = state;
  let buses;
  let stChrtStatus = state.stChrtStatus;
  let showPassenger = state.showPassenger;
  let stChrtOthrDtls = state.stChrtOthrDtls;
  let busImgDtls = state.busImgDtls;
  let tripDetails = state.tripDetails;
  let middleRoute = state.middleRoute;
  let order = state.order;
  let couponDetails = state.couponDetails;
  let header = state.header;
  let sortBy = state.sortBy;
  let serviceTypeFilterList = state.serviceTypeFilterList;
  let routePkpDrp = state.routePkpDrp;
  let seatChartErrorMsg = state.seatChartErrorMsg;
  let pathDtls = state.pathDtls;
  let levyandConcData = state.levyandConcData
  let routecodeDtls = state.routecodeDtls;
  switch (action.type) {
    case types.GET_SEARCH_PARAMS:
      return Object.assign({}, state, {
        searchParams: action.data,
      });
    case types.GET_SEARCH_RES:
      const allAmen = action.data ? getAmen(action.data) : false;
      const disBuses = action.data ? getDiscount(action.data) : false;
      //const filterBuses = disBuses ? disBuses.filter((el) => el.AvailableSeats > 0) : disBuses;
      const filterBuses = disBuses;
      return Object.assign({}, state, {
        data: disBuses,
        buses: filterBuses,
        allAmen,
      });
    case types.UPDATE_BUS:
      return Object.assign({}, state, {
        buses: action.data,
      });
    // Time Filter
    case types.UPDATE_FILTER_TIME:
      currState.time = action.data;
      buses = parseFilter(currState);
      return Object.assign({}, state, {
        time: action.data,
        buses,
      });
    // Coach filter
    case types.UPDATE_FILTER_COACH:
      currState.coach = action.data;
      buses = parseFilter(currState);
      return Object.assign({}, state, { coach: action.data, buses });
    // Amen filter
    case types.UPDATE_FILTER_BUS_SERVICE:
      currState.serviceType = action.data;
      buses = parseFilter(currState, serviceTypeFilterList);
      return Object.assign({}, state, { serviceType: action.data, buses });
    case types.UPDATE_FILTER_BOARDING_POINT:
      currState.boardingPointFilter = action.data;
      buses = parseFilter(currState, '', routePkpDrp.pdroutes);
      return Object.assign({}, state, { boardingPointFilter: action.data, buses });
    case types.UPDATE_FILTER_DROPPING_POINT:
      currState.droppingPointFilter = action.data;
      buses = parseFilter(currState, '', routePkpDrp.pdroutes);
      return Object.assign({}, state, { droppingPointFilter: action.data, buses });

    case types.UPDATE_FILTER_PRICE:
      currState.priceRangeFilter = action.data;
      buses = parseFilter(currState);
      return Object.assign({}, state, { priceRangeFilter: action.data, buses });
    case types.UPDATE_FILTER_AMEN:
      currState.amenities = action.data;
      buses = parseFilter(currState);
      return Object.assign({}, state, { amenities: action.data, buses });
    // Reset filter
    case types.UPDATE_FILTER_RESET:
      currState.time = [];
      currState.amenities = [];
      currState.coach = [];
      currState.serviceType = [];
      currState.boardingPointFilter = [];
      currState.droppingPointFilter = [];
      currState.priceRangeFilter = [];

      buses = parseFilter(currState);
      return Object.assign({}, state, {
        time: [],
        amenities: [],
        coach: [],
        serviceType: [],
        boardingPointFilter: [],
        droppingPointFilter: [],
        priceRangeFilter: [],
        buses,
      });

    case types.UPDATE_SEAT_CHART:
      let stChrtStatus = {};
      stChrtStatus[action.rsid] = action.data;
      return Object.assign({}, state, {
        stChrtStatus,
      });
    case types.UPDATE_SHOW_PASSENGER:
      return Object.assign({}, state, {
        showPassenger: { ...action.data }
      });
    case types.UPDATE_SEAT_CHART_DET:
      stChrtOthrDtls[action.rsid] = action.data;
      return Object.assign({}, state, {
        stChrtOthrDtls,
      });
    case types.UPDATE_BUS_IMAGE:
      busImgDtls[action.rsid] = action.data;
      return Object.assign({}, state, {
        busImgDtls,
      });
    case types.UPDATE_TRIP_DET:
      tripDetails[action.rsid] = action.data;
      return Object.assign({}, state, {
        tripDetails,
      });
    case types.UPDATE_MIDDLE_ROUTE:
      middleRoute[action.rsid] = action.data;
      return Object.assign({}, state, {
        middleRoute,
      });
    case types.UPDATE_CHECKOUT_DET:
      return Object.assign({}, state, {
        order: action.data,
      });
    case types.UPDATE_ORDER_TOKEN:
      return Object.assign({}, state, {
        orderToken: action.data,
      });
    case types.UPDATE_CONTACT_DETAIL:
      return Object.assign({}, state, {
        contactDetail: { mobile: action.data.mobile, email: action.data.email, loginType: action.data.loginType },
      });
    case types.UPDATE_LOGIN_DATA:
      return Object.assign({}, state, {
        loginData: { email: action.data.email, mobile: action.data.mobile, password: action.data.password },
      });
    case types.UPDATE_USER_NAME:
      order[action.param].seatDetails[action.seat].name = action.data;
      return Object.assign({}, state, {
        order,
      });
    case types.UPDATE_USER_AGE:
      order[action.param].seatDetails[action.seat].age = action.data;
      return Object.assign({}, state, {
        order,
      });
    case types.UPDATE_USER_GENDER:
      order[action.param].seatDetails[action.seat].gender = action.data;
      return Object.assign({}, state, {
        order,
      });
    case types.UPDATE_USER_CONCESSIONTYPE:
      order[action.param].seatDetails[action.seat].concessionType = action.data;
      return Object.assign({}, state, {
        order,
      });

    case types.UPDATE_USER_IDCARDNO:
      order[action.param].seatDetails[action.seat].idCardNo = action.data;
      return Object.assign({}, state, {
        order,
      });

    case types.UPDATE_USER_IDCARDTYPE:
      order[action.param].seatDetails[action.seat].idCardType = action.data;
      return Object.assign({}, state, {
        order,
      });
    case types.UPDATE_USER_NATIONALITY:
      order[action.param].seatDetails[action.seat].nationality = action.data;
      return Object.assign({}, state, {
        order,
      });
    case types.UPDATE_COUPON_LIST:
      couponDetails = action.data;
      return Object.assign({}, state, {
        couponDetails,
      });
    case types.UPDATE_HEADER_TEXT:
      header = action.text;
      return Object.assign({}, state, {
        header,
      });
    case types.UPDATE_LOADER:
      return Object.assign({}, state, { loader: action.data });
    case types.UPDATE_SORT_BY:
      return Object.assign({}, state, { sortBy: action.data })
    case types.UPDATE_SERVICE_TYPE_FILTER:
      const serviceFilterList = [...action.data];
      return Object.assign({}, state, { serviceTypeFilterList: serviceFilterList })
    case types.UPDATE_SEATCHART_ERROR_MSG:
      seatChartErrorMsg[action.rsid] = action.msg;
      return Object.assign({}, state, seatChartErrorMsg)
    case types.UPDATE_PATH_DTLS:
      pathDtls[action.rsid] = action.data;
      return Object.assign({}, state, pathDtls)
    case types.UPDATE_ROUTECODE_DTLS:
      routecodeDtls[action.rsid] = action.data;
      return Object.assign({}, state, routecodeDtls)
    case types.UPDATE_BUS_SERVICE_TYPE:
      return Object.assign({}, state, { busType: action.busType })
    case types.UPDATE_TRIP_CODE:
      return Object.assign({}, state, { tripCode: action.data })
    case types.UPDATE_ROUTES_PKPDRP:
      return Object.assign({}, state, { routePkpDrp: action.data })
    case types.UPDATE_FARE_RANGE:
      return Object.assign({}, state, { fareRange: action.data })
    case types.UPDATE_LEVY_CONCESSION:
      levyandConcData[action.id] = action.data
      return Object.assign({}, state, levyandConcData)
    case types.UPDATE_PNR_ENQUIRY_DATA:
      return Object.assign({}, state, { pnrEnquiryData: action.data })

    case types.UPDATE_PNR_ENQUIRY_TRIPDATA:
      return Object.assign({}, state, { pnrEnquiryTripData: { ...action.data } })
    case types.UPDATE_CAPTCHA_TOKEN:
      return Object.assign({}, state, { recaptchaToken: action.token })
    case types.UPDATE_SATATIC_CITY_LIST:
      return Object.assign({}, state, { staticCityList: action.data })
    case types.UPDATE_CITY_LIST:
      return Object.assign({}, state, { cityList: action.data })
    case types.UPDATE_PACKAGE_DATA:
        return Object.assign({}, state, { packageData: action.data })  
    case types.UPDATE_PACKAGE_CITY:
        return Object.assign({}, state, { packageCity: action.data })
    case types.UPDATE_PACKAGE_CATEGORY:
        return Object.assign({}, state, { packageCategory: action.data })
    case types.UPDATE_PACKAGE_TOUR:
      return Object.assign({}, state, { packageTour: action.data })             
    default:
      return state;
  }
};

// const searchParseStaticData = (data) => {
//   const buses = data.Buses;
//   const amenArr = data.AllAmenities;
//   const coach = ['Seater / Semi-Sleeper', 'Sleeper', 'AC', 'Non AC', 'Volvo / Mercedes', 'Non Volvo'];
//   let minFare, maxFare, minDepHr, maxDepHr, pickups = [], dropoffs = [], operators = [], amenities = [];
//   buses.forEach((el, index) => {
//     if (index === 0) {
//         minFare = el.BusStatus.DiscFares[0];
//         maxFare = el.BusStatus.DiscFares[0];
//         minDepHr = new Date(el.DeptTime).getHours();
//         maxDepHr = new Date(el.DeptTime).getHours();
//     }
//     if (index > 0) {
//         minFare = el.BusStatus.DiscFares[0] < minFare ? el.BusStatus.DiscFares[0] : minFare;
//         maxFare = el.BusStatus.DiscFares[0] > maxFare ? el.BusStatus.DiscFares[0] : maxFare;
//         minDepHr = new Date(el.DeptTime).getHours() < minDepHr ? new Date(el.DeptTime).getHours() : minDepHr;
//         maxDepHr = new Date(el.DeptTime).getHours() > maxDepHr ? new Date(el.DeptTime).getHours() : maxDepHr;
//     }
//     el.Pickups.forEach(pick => pickups.indexOf(pick.PickupName) === -1 ? pickups.push(pick.PickupName) : '');
//     el.Dropoffs.forEach(drop => dropoffs.indexOf(drop.DropoffName) === -1 ? dropoffs.push(drop.DropoffName) : '');
//     el.Amenities.forEach(amen => amenities.indexOf(amenArr[amen]) === -1 ? amenities.push(amenArr[amen]) : '');
//     if (operators.indexOf(el.CompanyName) === -1) {operators.push(el.CompanyName);}
//   });

//   return {
//     minPrice: minFare,
//     maxPrice: maxFare,
//     minDepHr: minDepHr,
//     maxDepHr: maxDepHr,
//     operators: operators,
//     amenities: amenities,
//     pickups: pickups,
//     dropoffs: dropoffs,
//     coach: coach
//   };
// }

const parseFilter = (st, serviceType, boardingPoints) => {
  const loop = st.data;
  const sortby = st.sortBy;
  let buses = [];
  for (let i = 0; i < loop.length; i++) {
    const val =
      timeFilter(loop[i], st.time) &&
      coachType(loop[i], st.coach, st.staticData.coach) &&
      amenFilter(loop[i], st.amenities, st.allAmen) &&
      busServiceType(loop[i], st.serviceType, serviceType) &&
      pickupsFilter(loop[i], st.boardingPointFilter, boardingPoints) &&
      dropoffFilter(loop[i], st.droppingPointFilter, boardingPoints) &&
      busFareFilter(loop[i], st.priceRangeFilter)

    if (val) {
      buses.push(loop[i]);
    }
  }

  if (buses.length > 0) {
    if (sortby === 1) {
      buses = buses.sort((a, b) => {
        return a.DepartureTime > b.DepartureTime
          ? 1
          : b.DepartureTime > a.DepartureTime
            ? -1
            : 0;
      });
    } else if (sortby === 2) {
      buses = buses.sort((a, b) => {
        return a.DepartureTime < b.DepartureTime
          ? 1
          : b.DepartureTime < a.DepartureTime
            ? -1
            : 0;
      });
    } else if (sortby === 3) {
      buses = buses.sort((a, b) => {
        return a.DiscFare < b.DiscFare ? 1 : b.DiscFare < a.DiscFare ? -1 : 0;
      });
    } else if (sortby === 4) {
      buses = buses.sort((a, b) => {
        return a.DiscFare > b.DiscFare ? 1 : b.DiscFare > a.DiscFare ? -1 : 0;
      });
    }
  }

  return buses;
};

const getAmen = (val) => {
  let amen = [];
  if (val) {
    val.forEach((el) => {
      if (el) {
        const amn = el.AmenitiesType.split(",");
        if (amn.length > 0) {
          amn.forEach((vl) => {
            if (amen.indexOf(vl) === -1 && vl !== "") {
              amen.push(vl);
            }
          });
        }
      }
    });
  }

  return amen;
};

const getDiscount = (val) => {
  val.forEach((el) => {
    if (el.DiscountAmt > 0) {
      el["DiscFare"] = el.Fare - el.DiscountAmt;
    } else if (el.DiscountPer > 0) {
      el["DiscFare"] = Math.round(el.Fare - (el.Fare * el.DiscountPer) / 100);
    } else {
      el["DiscFare"] = el.Fare;
    }
  });
  return val;
};

export default searchReducer;
